import * as Yup from 'yup'

import { formValidationSchemaNoChanged } from '../../Form'

import { DOCUMENT_MOVE_TO_ACTION_MODAL_VALIDATION_FIELD_CAN_WRITE } from './DocumentMoveToActionModal.constants'

function isDocumentMoveToActionEqual({ initialValues, values }) {
  return values.currentFolder?.id.toString() === initialValues.parent
}

export function getDocumentsDataItems(data) {
  return data.data.objects
}

export function isValidValueForSearch(value) {
  return value?.text?.trim().length >= 1
}

export function getValidationSchema({ parent }) {
  return Yup.object({
    [DOCUMENT_MOVE_TO_ACTION_MODAL_VALIDATION_FIELD_CAN_WRITE]:
      Yup.boolean().isTrue(true),
  }).concat(
    formValidationSchemaNoChanged({
      initialValues: { parent },
      isEqual: isDocumentMoveToActionEqual,
    })
  )
}
